export enum TrialStatus {
    Active = 'Active',
    Cancelled = 'Cancelled',
    Expired = 'Expired',
    Promoted = 'Promoted'
}
